class LpOtwFaq extends HTMLElement {
  connectedCallback() {
    this.animations = new Map();
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.animations.forEach((state, item) => this.finish(item, state));
  }

  finish(item, state) {
    if (this.animations.get(item) !== state) return;
    item.open = state.open;
    state.animation.cancel();
    item.style.removeProperty('height');
    item.style.removeProperty('overflow');
    this.animations.delete(item);
  }

  handleClick = (event) => {
    const summary = event.target.closest('.lp-otw-faq__question');
    if (!summary || summary.closest('lp-otw-faq') !== this || event.defaultPrevented) return;
    if (event.target.closest('a, button, input, select, textarea')) return;

    const item = summary.parentElement;
    const previous = this.animations.get(item);
    const open = previous ? !previous.open : !item.open;
    if (!item.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      if (previous) this.finish(item, previous);
      return;
    }

    event.preventDefault();
    const start = item.getBoundingClientRect().height;
    if (previous) previous.animation.cancel();
    item.style.removeProperty('height');
    item.style.overflow = 'hidden';
    // Keep <details> open until the collapse finishes so the answer stays painted.
    item.open = true;
    const styles = getComputedStyle(item);
    const end = open
      ? item.getBoundingClientRect().height
      : summary.getBoundingClientRect().height
        + parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom)
        + parseFloat(styles.borderTopWidth) + parseFloat(styles.borderBottomWidth);
    item.style.height = `${start}px`;
    const animation = item.animate(
      [{ height: `${start}px` }, { height: `${end}px` }],
      { duration: 240, easing: 'ease-in-out', fill: 'forwards' }
    );
    const state = { animation, open };
    this.animations.set(item, state);
    animation.onfinish = () => this.finish(item, state);
  };
}

if (!customElements.get('lp-otw-faq')) {
  customElements.define('lp-otw-faq', LpOtwFaq);
}
